/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateDishLikesBodyRequest } from '../../models/update-dish-likes-body-request';

export interface PatchDishByDishidLikes$Params {
  DishId: number;
  body: UpdateDishLikesBodyRequest;
}

export function patchDishByDishidLikes(
  http: HttpClient,
  rootUrl: string,
  params: PatchDishByDishidLikes$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patchDishByDishidLikes.PATH, 'patch');
  if (params) {
    rb.path('DishId', params.DishId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    }),
  );
}

patchDishByDishidLikes.PATH = '/Restaurants/dish/{DishId}/likes';
